import {Component, OnInit} from '@angular/core';
import * as moment from 'moment';
import {Subject} from 'rxjs/Subject';
import Swal from 'sweetalert2';
import {Constants} from '../../constants';
import {DataManagementService} from '../../services/data-management.service';
import {Router} from '@angular/router';
import {AccessService} from '../../services/access.service';

@Component({
    selector: 'app-view-rounds',
    templateUrl: './view-rounds.component.html',
    styleUrls: ['./view-rounds.component.css']
})
export class ViewRoundsComponent implements OnInit {
    dtTrigger: Subject<string> = new Subject();
    dtOptions: DataTables.Settings = {};
    rounds;
    errorMessage: string = undefined;

    constructor(private dmService: DataManagementService,
                private accessService: AccessService) {
    }

    getAllRounds(): void {
        this.dmService.getAll(Constants.ROUND_SETTINGS)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.rounds = response.data;
                        if (this.rounds.length === 0) {
                            this.errorMessage = 'There is no data available for rounds.';
                        } else {
                            this.dtTrigger.next();
                        }
                    } else if (response.status === 'fail') {
                        if (response.data.hasOwnProperty('message')) {
                            this.errorMessage = response.data.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    getFormattedTime(dateTime): string {
        if (dateTime === undefined || dateTime === null || dateTime === '' || dateTime === 'undefined') {
            return '';
        }
        return moment(dateTime).subtract(330, 'minutes').format('YYYY-MM-DD hh:mm a');
    }

    deleteRound(round: any) {
        let clearResponse;
        const that = this;
        const body = {
            outgoing_round_id: round.outgoing_round_id,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
        };
        Swal({
            type: 'question',
            title: 'Confirm',
            html: '<p>Do you want to delete ' + round.outgoing_term_name + '_' + round.outgoing_round_name + '</p>',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.clearDataByParameter(body, Constants.DELETE_ROUND).subscribe(response => {
                        clearResponse = response;
                        resolve(clearResponse);
                    }, error => {
                        clearResponse = error;
                        reject(clearResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (clearResponse.status === 'success') {
                    that.getAllRounds();
                    Swal({
                        type: 'success',
                        title: 'Success',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: 'Successfully deleted the ' + round.outgoing_term_name + '_' + round.outgoing_round_name,
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                } else if (clearResponse.status === 'fail') {
                    if (clearResponse.hasOwnProperty('message') && clearResponse.message !== null &&
                        clearResponse.message !== '' && clearResponse.message !== undefined) {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            width: 600,
                            padding: 80,
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Failed to delete round because ' + clearResponse.message + ' </p>',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    } else {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            width: 600,
                            padding: 80,
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Failed to delete round, Please contact support team </p>',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    }
                }
            }
        }, function (cancel) {
            console.log(cancel);
        });
    }

    ClearResults(round: any) {
        let clearResponse;
        const that = this;
        const body = {
            outgoing_round_id: round.outgoing_round_id,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
        };
        Swal({
            type: 'question',
            title: 'Confirm',
            html: '<p>Do you want to clear results?</p>',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.javaPostDataCall(body, Constants.CLEAR_RESULTS).subscribe(response => {
                        clearResponse = response;
                        resolve(clearResponse);
                    }, error => {
                        clearResponse = error;
                        reject(clearResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (clearResponse.status === 'success') {
                    that.getAllRounds();
                    Swal({
                        type: 'success',
                        title: 'Success',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: 'Successfully cleared the results.',
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                } else if (clearResponse.status === 'fail') {
                    if (clearResponse.hasOwnProperty('message') && clearResponse.message !== null &&
                        clearResponse.message !== '' && clearResponse.message !== undefined) {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            width: 600,
                            padding: 80,
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Failed to clear results because ' + clearResponse.message + ' </p>',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    }
                }
            }
        }, function (cancel) {
            console.log(cancel);
        });
    }

    generateResults(round: any) {
        let generateResponse;
        const that = this;
        const body = {
            outgoing_round_id: round.outgoing_round_id,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
        };
        Swal({
            type: 'question',
            title: 'Confirm',
            html: '<p>Do you want to generate results?</p>',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.javaPostDataCall(body, Constants.GENERATE_RESULTS).subscribe(response => {
                        generateResponse = response;
                        resolve(generateResponse);
                    }, error => {
                        generateResponse = error;
                        reject(generateResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (generateResponse.status === 'success') {
                    that.getAllRounds();
                    Swal({
                        type: 'success',
                        title: 'Success',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: 'Successfully generated the results.',
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                } else if (generateResponse.status === 'fail') {
                    if (generateResponse.hasOwnProperty('message') && generateResponse.message !== null &&
                        generateResponse.message !== '' && generateResponse.message !== undefined) {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            width: 600,
                            padding: 80,
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Failed to generate results because ' + generateResponse.message + ' </p>',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    }
                }
            }
        }, function (cancel) {
            console.log(cancel);
        });
    }

    sendUniversityAllotmentToStudents(round: any) {
        let sendEmailResponse;
        const that = this;
        const body = {
            outgoing_round_id: round.outgoing_round_id,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
        };
        Swal({
            type: 'question',
            title: 'Confirm',
            html: '<p>Do you want to send university allotment to students?</p>',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.javaPostDataCall(body, Constants.SEND_ROUND_RESULT).subscribe(response => {
                        sendEmailResponse = response;
                        resolve(sendEmailResponse);
                    }, error => {
                        sendEmailResponse = error;
                        reject(sendEmailResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (sendEmailResponse.status === 'success') {
                    that.getAllRounds();
                    Swal({
                        type: 'success',
                        title: 'Success',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: sendEmailResponse.data,
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                } else if (sendEmailResponse.status === 'fail') {
                    if (sendEmailResponse.hasOwnProperty('message') && sendEmailResponse.message !== null &&
                        sendEmailResponse.message !== '' && sendEmailResponse.message !== undefined) {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            width: 600,
                            padding: 80,
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: sendEmailResponse.message,
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    }
                }
            }
        }, function (cancel) {
            console.log(cancel);
            if (cancel.hasOwnProperty('status') && cancel.status === 404) {
                Swal({
                    type: 'error',
                    title: 'Fail',
                    width: 600,
                    padding: 80,
                    showCancelButton: false,
                    showConfirmButton: true,
                    html: cancel.message,
                }).then(function (res) {
                    console.log(res);
                }, function (timer) {
                    console.log(timer);
                });
            }
        });
    }

    canAccessOIA() {
        return this.accessService.canAccessOIA();
    }

    canAccessEC() {
        return this.accessService.canAccessEC();
    }

    ngOnInit() {
        this.getAllRounds();
        this.dtOptions = {
            paging: true,
            retrieve: true,
            destroy: true,
            lengthChange: true,
            info: false
        };
    }

}
